import * as _ from 'lodash';

export enum Theme {
    Dark = 'dark',
    Light = 'light'
}

export class MapStyle {
    default?: boolean;
    name?: string;
    type?: string;
    theme?: Theme;
    imageUrl?: string;
    icon?: string;
    config?: { [key: string]: any };

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }

    public get iconUrl(): string {

        if (this.icon !== undefined) {
            return `url('/assets/img/${this.icon}')`;
        }
        return `url('/assets/img/${this.icon}')`;
    }
}

export class MapDataSetLayer {
    sourceUrl: string;
    sourceLayer: string;
    layerType: string;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}

export class MapConfig {
    dataSetLayers: MapDataSetLayer[];
    styles: MapStyle[];
    layers: string[];

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (this.styles) {
            this.styles = _.map(this.styles, s => new MapStyle(s));
        }

        if (this.dataSetLayers) {
            this.dataSetLayers = _.map(this.dataSetLayers, d => new MapDataSetLayer(d));
        }
    }

    // gets the default map style if it exists
    public getDefaultMapStyle(): MapStyle {
        if (this.styles && this.styles.length > 0) {
            return _.find(this.styles, style => style.default);
        }
        return undefined;
    }
}
